<template>
  <div class="gala-list">
    <timeline v-if="isDesktop" :timeList="timeList" :active="active" class="gala-list__timeline" @change="onChange" />

    <div class="row">
      <div class="gala-list__col col-sm-6 col-md-4 col-lg-3" v-for="(item, index) in filteredGalaList" :key="`event-${index}`">
        <slot :item="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Timeline from './Timeline'

export default {
  components: {
    Timeline
  },
  props: {
    galaList: Array
  },
  data () {
    return {
      active: -1
    }
  },
  computed: {
    isDesktop () {
      return this.$mq.resize && this.$mq.above(this.$mv.md)
    },
    timeList () {
      const start = this.galaList.map(item => item.start)
      const list = [...new Set(start)]

      return list
    },
    filteredGalaList () {
      if (this.active < 0) return this.galaList

      const time = this.active < this.timeList.length ? parseInt(this.timeList[this.active]) : 24

      return this.galaList.filter(item => {
        const interval = {}

        interval.start = parseInt(item.start)

        if (item.end) {
          interval.end = item.end === '00:00' ? 24 : parseInt(item.end)
        } else {
          interval.end = interval.start
        }

        return time >= interval.start && time <= interval.end
      })
    }
  },
  methods: {
    onChange (index) {
      this.active = index
    }
  }
}
</script>

<style lang="scss" scoped>
.gala-list {
  &__timeline {
    margin-bottom: 45px;
  }

  &__col {
    margin-bottom: 30px;
  }
}
</style>
